import React, { useState, useEffect } from "react";
import "./announcement.css";
import MetaData from "../MetaData.js";
import Nav from "../nav.js";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const filterOptions = [
  "All",
  "Business",
  "Alert",
  "Legal",
  "People",
  "Expertise",
];

export default function Announcements() {
  const [news, setNews] = useState([]);
  const [selectedType, setSelectedType] = useState("All");
  const [banner, setBanner] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [announcementRes, bannerRes] = await Promise.all([
          axios.get("/api/v1/announcements"),
          axios.get("/api/v1/announcement-banner"),
        ]);

        setNews(announcementRes.data.announcements);

        setBanner(bannerRes.data.banner);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const filteredNews =
    selectedType === "All"
      ? news
      : news.filter((item) => item.type === selectedType);

  const truncateText = (text = "", wordLimit = 20) => {
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <>
      <MetaData title="Announcements | GLOCRE Private Limited" />
      <Nav />

      <section className="announcement-hero">
        {/* Banner */}
        <div className="announcement-banner-inner">
          {banner?.bannerImage ? (
            <img
              src={banner.bannerImage}
              alt="banner"
              className="announcement-banner-img"
              loading="eager"
            />
          ) : (
            <div className="announcement-banner-skeleton"></div>
          )}
        </div>

        <div className="news-container">
          <div className="headline border-b border-gray-500 pt-0">
            <h2 className="hd mb-3">Recent News</h2>

            <div className="dropdown">
              <button
                className="btn btn-light announcement-btn"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                {selectedType}
              </button>

              {showDropdown && (
                <ul className="dropdown-menu show">
                  {filterOptions.map((option, i) => (
                    <li key={i}>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          setSelectedType(option);
                          setShowDropdown(false);
                        }}
                      >
                        {option}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="news-left">
            {filteredNews.map((news, i) => (
              <div
                key={i}
                onClick={() => navigate(`/announcements/${news._id}`)}
                className="news-item"
              >
                <p className="news-date">
                  {new Date(news.createdAt).toLocaleDateString()}
                </p>

                <div className="news-left">
                  <p className="news-title">{news.subject}</p>
                  <p className="news-des">
                    {truncateText(news.mainParagraph, 20)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
